module.exports = __webpack_public_path__ + "static/media/certyfikat-13.2f34eff4.png";